import styled, { keyframes } from "styled-components";

const spinAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const StyledLoaderWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  font-family: ${(props) => props.theme.typography.textsFont};
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: inherit;
  svg {
    margin-top: -100px;
    width: 90%;
    height: 300px;
  }
  p {
    font-size: 14px;
    margin-top: 20px;
    font-weight: 600;
    font-family: ${(props) => props.theme.typography.textsFont};
    color: ${({ theme }) => theme.colors.text};
  }
`;

export const StyledSpinner = styled.div`
  display: inline-block;
  width: 40px;
  height: 40px;
  border: 4px solid ${({ theme }) => theme.colors.card};
  border-radius: 50%;
  border-top: 4px solid ${({ theme }) => theme.colors.primary};
  animation: ${spinAnimation} 1s linear infinite;
`;
